export interface Page {
    id: number | null;
    title: string | null;
    slug: string | null;
    page_text: string | null;
    media: any[];
    excerpt: string | null;
    featured_image: string | null;
}

export const createDefaultPage = (): Page => {
    return {
        id: null,
        title: null,
        slug: null,
        page_text: null,
        media: [],
        excerpt: null,
        featured_image: null,
    }
}

export interface ContactCompany {
    id: number | null;
    company_name: string | null;
    company_address: string | null;
    company_website: string | null;
    company_email: string | null;
}

export interface Contact {
    id: number | null;
    contact_first_name: string | null;
    contact_last_name: string | null;
    contact_phone_1: string | null;
    contact_phone_2: string | null;
    contact_email: string | null;
    contact_skype: string | null;
    contact_address: string | null;
    company_id: number | null;
    contact_type: string | null;
    company: ContactCompany | null;
}

export const createDefaultContact = (): Contact => {
    return {
        id: null,
        contact_first_name: null,
        contact_last_name: null,
        contact_phone_1: null,
        contact_phone_2: null,
        contact_email: null,
        contact_skype: null,
        contact_address: null,
        company_id: null,
        contact_type: null,
        company: null,
    }
}

export interface FaqQuestion {
    id: number | null;
    question: string | null;
    answer: string | null;
    category_id: number | null;
    category: FaqCategory | null;
}

export interface Review {
    rating: number | null;
    title: string | null;
    body: string | null;
    author: string | null;
    city_name: string | null;
}

export interface FaqCategory {
    id: number | null;
    category: string | null;
    questions: FaqQuestion[];
}